import React from 'react';

import { di } from 'react-magnetic-di';

import { Box } from '@atlaskit/primitives/compiled/box';
import { Text } from '@atlaskit/primitives/compiled/text';

import { asFormOptionField } from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { useFormField } from '../../../../../../../../controllers/form-renderer-store';

export const ViewSingleSelectInput = ({
	fieldId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);
	const formField = useFormField({ fieldId });
	const formOptionField = asFormOptionField(formField);

	if (formOptionField === undefined) {
		return <></>;
	}

	return (
		<Box>
			<Text testId="field-input-single-select-view">
				{formOptionField.value?.otherOptionText !== undefined
					? formOptionField.value.otherOptionText
					: formOptionField.value?.options[0]?.label}
			</Text>
		</Box>
	);
};
